import { Component, OnInit, Input, OnChanges, OnDestroy } from '@angular/core';
import { WeatherService } from 'src/app/services/weather.service';
import { Weather } from 'src/app/clases/weather';
import { interval, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-weather-snack',
  templateUrl: './weather-snack.component.html',
  styleUrls: ['./weather-snack.component.scss']
})
export class WeatherSnackComponent implements OnInit, OnDestroy {

  weather: Weather;
  subscription: Subscription = new Subscription;

  constructor(private weatherService: WeatherService) { }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  ngOnInit() {
    this.subscription.add(this.weatherService.getWeather("cochabamba", "bolivia")
      .subscribe(data => {
        interval(3600).pipe(
          map(tick =>{
            this.weather = new Weather();
            this.weather.city = data.name;
            this.weather.country = data.sys.country;
            this.weather.temp = data.main.temp;
            this.weather.tempMin = data.main.temp_min;
            this.weather.tempMax = data.main.temp_max;
            let dataweather = data.weather[0];
            this.weather.icon = dataweather.icon;
            this.weather.description = dataweather.description;
            return tick;
          })
        ).subscribe();
        this.weather = new Weather();
        this.weather.city = data.name;
        this.weather.country = data.sys.country;
        this.weather.temp = data.main.temp;
        this.weather.tempMin = data.main.temp_min;
        this.weather.tempMax = data.main.temp_max;
        let dataweather = data.weather[0];
        this.weather.icon = dataweather.icon;
        this.weather.description = dataweather.description;
      }));
  }
}
